import { Link } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import BeActiveBtn from 'assets/images/buttons/be-active-eng.png';
import BeActiveHoverBtn from 'assets/images/buttons/be-active-eng-hover.png';
import BeActiveChnBtn from 'assets/images/buttons/be-active-chn.png';
import BeActiveChnHoverBtn from 'assets/images/buttons/be-active-chn-hover.png';
import LiveHealthierBtn from 'assets/images/buttons/live-healthier-eng.png';
import LiveHealthierHoverBtn from 'assets/images/buttons/live-healthier-eng-hover.png';
import LiveHealthierChnBtn from 'assets/images/buttons/live-healthier-chn.png';
import LiveHealthierChnHoverBtn from 'assets/images/buttons/live-healthier-chn-hover.png';
import ThriveTogetherBtn from 'assets/images/buttons/thrive-together-eng.png';
import ThriveTogetherHoverBtn from 'assets/images/buttons/thrive-together-eng-hover.png';
import ThriveTogetherChnBtn from 'assets/images/buttons/thrive-together-chn.png';
import ThriveTogetherChnHoverBtn from 'assets/images/buttons/thrive-together-chn-hover.png';
import VolleyballHoverBtn from 'assets/images/buttons/activity-volleyball-buttons-hover.png';
import PickleballHoverBtn from 'assets/images/buttons/activity-pklball-buttons-hover.png';
import HikingHoverBtn from 'assets/images/buttons/activity-hiking-buttons-hover.png';
import TaichiHoverBtn from 'assets/images/buttons/activity-taichi-buttons-hover.png';
import WimssdayHoverBtn from 'assets/images/buttons/activity-wimssday-buttons-hover.png';
import CoconutDrinkIcon from 'assets/images/pictures/coconut-drink-small-2.png';
import VolleyballTabIcon from 'assets/images/pictures/icon-vb-tab.png';
import PickleballTabIcon from 'assets/images/pictures/icon-pkb-tab.png';
import TaichiTabIcon from 'assets/images/pictures/icon-taichi-tab.png';
import HikingTabIcon from 'assets/images/pictures/icon-hk-tab.png';
import WimssDayTabIcon from 'assets/images/pictures/icon-wimss-day-tab.png';
import COELogo from 'assets/images/pictures/coe-logo.png';
import EPCORLogo from 'assets/images/pictures/epcor-logo.png';
import GOALogo from 'assets/images/pictures/goalogo.png'
import NingBio from 'assets/images/pictures/ning_bio.png';
import JianboBio from 'assets/images/pictures/jianbo_bio.jpg';
import ZhaohuiBio from 'assets/images/pictures/zhaohui_bio.jpg';
import JeffBio from 'assets/images/pictures/jeff_bio.jpg';
import CharlieBio from 'assets/images/pictures/charlie_bio.jpg';
import WIMSSDay from 'assets/web-contents/Wimssday';
import WIMSSDayCN from 'assets/web-contents/Wimssdaycn';

//import components for related pages
// import ActivityComponents from 'pages/components/ActivityComponents';

const TabIconSize =
  window.innerWidth < 600
    ? { width: 80, height: 80 }
    : { width: 120, height: 120 };

export const WebsiteTexts = [
  {
    page: 'home',
    paragraphs: [
      {
        id: 0,
        title: 'YEG Wellness-In-Motion Synergy Society',
        subtitle: 'Your Pathway to a Healthier, Happier You!',
        action: null,
        button: null,
        btn_hover: null,
        content: null,
      },
      // {
      //   id: 1,
      //   title: null,
      //   subtitle: 'BE ACTIVE',
      //   action: '/activities',
      //   button: BeActiveBtn,
      //   btn_hover: BeActiveHoverBtn,
      //   content:
      //     "We are excited to welcome you to the YEG Wellness-In-Motion Synergy Society (YEGWIMSS), a community dedicated to promoting holistic well-being and a balanced lifestyle through various of leisure activities such as outdoor activities, indoor sports, fitness, and so on. Whether you're looking to enhance your mental, physical, or emotional health or to meet friends and families with mutual interests, our society is here to support and guide you on your wellness journey.",
      // },
      {
        id: 1,
        title: null,
        subtitle: 'BE ACTIVE',
        action: '/activities',
        button: BeActiveBtn,
        btn_hover: BeActiveHoverBtn,
        content:(
          <div>
            We are excited to welcome you to the YEG Wellness-In-Motion Synergy Society (YEGWIMSS), a community dedicated to promoting holistic well-being and a balanced lifestyle through various of leisure activities such as outdoor activities, indoor sports, fitness, and so on. Whether you're looking to enhance your mental, physical, or emotional health or to meet friends and families with mutual interests, our society is here to support and guide you on your wellness journey. {' '}
            <span>
              <strong>
                Our recent WIMSS Day 2026 Hiking event was a great success. {' '}
                Click below button to find more details!
              </strong> 
            </span>
          </div>
        ),
          
      },
      {
        id: 2,
        title: null,
        subtitle: 'We Focus on Overall Health',
        action: '/schedules',
        button: LiveHealthierBtn,
        btn_hover: LiveHealthierHoverBtn,
        content:
          "At YEGWIMSS, we believe wellness goes beyond physical fitness — it's about nurturing the mind, body, and soul. Our diverse range of activities includes life experience sessions, both indoor and outdoor activities, nutrition talks, low-intensity sports, and stress-relief practices. We aim to foster a positive, inclusive environment where members can connect, exchange ideas, and explore ways to cultivate happiness and peace in their daily lives.\nAs part of our society, you'll have access to a variety of events and resources designed to help you lead a healthier, more balanced life. Whether you're new to wellness or an experienced practitioner, there's something here for everyone, and we encourage you to take part, get involved, and grow together with us.",
      },
      {
        id: 3,
        title: null,
        subtitle: 'Join Us to Build a Joyful and Caring Community',
        action: '/join-us',
        button: ThriveTogetherBtn,
        btn_hover: ThriveTogetherHoverBtn,
        content:
          "We look forward to sharing this journey with you and helping you cultivate wellness in all aspects of your life. Join us in building a supportive, vibrant community dedicated to wellness, personal growth, and caring for one another!\nHere's to a healthier, happier you!",
      },
    ],
  },
  {
    page: 'activities',
    paragraphs: [
      {
        id: 0,
        title: 'Variety of Activities Available in YEGWIMSS',
        subtitle: 'There is One for You, More to Come!',
        action: null,
        button: null,
        btn_hover: null,
        content: null,
      },
      {
        id: 1,
        title: null,
        subtitle: "Gather your kneepads, folks—it's volleyball time!",
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: VolleyballHoverBtn,
        content:
          "Welcome to our volleyball group, a community of non-professional volleyball enthusiasts who share a love for the game and the joy it brings. Here, we prioritize fun, fitness, and camaraderie over competition, so no need to worry about mistakes—they're all part of the game! Whether you're a beginner or an experienced player, our goal is to create a welcoming environment where everyone can enjoy playing, stay active, and build friendships along the way.",
      },
      {
        id: 2,
        title: null,
        subtitle: 'Time to paddle up and dink around!',
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: PickleballHoverBtn,
        content:
          'Come on, pickleball lovers! We are a vibrant community of amateur pickleball enthusiasts who play for fun, fitness, and the love of the game. As one of the most popular sports around, pickleball offers the perfect mix of excitement and health benefits for players of all skill levels. Here, we believe in sharing the court and spreading the joy, fostering a friendly and inclusive environment where everyone can enjoy the game, stay active, and make lasting connections.',
      },
      {
        id: 3,
        title: null,
        subtitle: "Grab your boots—it's time to explore the nature!",
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: HikingHoverBtn,
        content:
          'Welcome to our outdoor exploring group, where we celebrate the beauty of nature while fostering a commitment to environmental protection. From hiking and camping to skiing and more, we offer a variety of well-planned trips and events that cater to adventurers of all interests and skill levels. Beyond the thrill of exploration, our group is about building a community — creating lasting friendships with like-minded nature lovers. Join us to discover the great outdoors, stay active, and make a positive impact on the environment!',
      },
      {
        id: 4,
        title: null,
        subtitle: 'Tai Chi — Poise in motion and stillness!',
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: TaichiHoverBtn,
        content:
          'Welcome to our Tai Chi group. The WIMSS Tai Chi Group is composed of practitioners with many years of experience. Their practice focuses on routines such as the 24-Form, 48-Form, Wu Style, and Chen Style, as well as Hands-pushing exercises.',
      },
      {
        id: 5,
        title: null,
        subtitle: "",
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: WimssdayHoverBtn,
        content: (
          <WIMSSDay />
        ),
      },
    ],
  },
  {
    page: 'schedules',
    paragraphs: [
      {
        id: 0,
        title: null,
        subtitle: null,
        action: null,
        button: null,
        btn_hover: null,
        content: null,
      },
      {
        id: 1,
        title: null,
        subtitle: 'Remaining volleyball gyms booked for this season',
        action: null,
        button: null,
        btn_hover: null,
        content:
          'Kindly review the available dates and gyms for our exciting volleyball games for the remainder of this season!',
      },
      {
        id: 2,
        title: null,
        subtitle: 'Available pickleball gyms booked for the rest of the season',
        action: null,
        button: null,
        btn_hover: null,
        content:
          'Please carefully check the available dates and gyms for the most popular pickleball games!',
      },
      {
        id: 3,
        title: null,
        subtitle: 'No specific schedule for our Outdoor Group!',
        action: null,
        button: null,
        btn_hover: null,
        content:
          'Please follow the Outdoor Wechat Group for the exciting outdoor adventures all year long!',
      },
      {
        id: 4,
        title: null,
        subtitle: 'Available Taichi gyms booked for the rest of the season',
        action: null,
        button: null,
        btn_hover: null,
        content:
          'Please carefully check the available dates and gyms for the Taichi Practices!',
      },
    ],
  },
  {
    page: 'news',
    paragraphs: [
      // {
      //   id: 0,
      //   title: 'Latest News and Events',
      //   subtitle: null,
      //   action: null,
      //   button: null,
      //   btn_hover: null,
      //   content:
      //     "Welcome to the WIMSS's latest updates! We're thrilled to share some exciting news and events happening in our community. Stay tuned for updates on our projects, volunteer opportunities, and stories of change as we work together to make a difference!",
      // },
      {
        id: 0,
        title: 'WIMSS has Joined Edmonton Corporate Wellness Program.',
        subtitle: '2024-11-15',
        action: null,
        button: null,
        btn_hover: null,
        content: (
          <div>
            WIMSS has joined Edmonton Corporate Wellness Program. Our members
            enjoy exclusive discounts on Rec Centre memberships! Get 20% off
            Annual Memberships or Continuous Monthly Memberships, and 15% off
            Multi-Admission Passes (5+ visits). For detailed information, visit{' '}
            <span>
              <a
                style={{ display: 'table-cell' }}
                href='https://www.edmonton.ca/activities_parks_recreation/corporate-wellness-program'
                target='_blank'
                rel='noreferrer'>
                Corporate Wellness Program
              </a>
            </span>
            . To take advantage of these offers, please{' '}
            <span>
              <a
                style={{ display: 'table-cell' }}
                href='mailto:info@wimss.org'
                target='_blank'
                rel='noreferrer'>
                request a membership confirmation letter
              </a>
            </span>{' '}
            from WIMSS.
          </div>
        ),
      },
      {
        id: 1,
        title: 'WIMSS Secured a Generous Sponsorship from EPCOR.',
        subtitle: '2024-12-18',
        action: null,
        button: null,
        btn_hover: null,
        content:
          "WIMSS would like to express our heartfelt gratitude for two of our members Ms. Yan Lu and Mr. Jingquan Liu's efforts in securing a generous sponsorship from EPCOR. This support is invaluable to the success of our outdoor hiking and other activities event, alleviating the pressures of planning and laying a solid foundation for a memorable occasion. EPCOR's sponsorship demonstrates the company's admirable focus on community engagement and social responsibility. With your support, we are more confident in achieving our vision of fostering happiness and wellness among all members. Thank you once again for your contribution!",
      },
      {
        id: 2,
        title: 'YEGWIMSS 2025 Annual General Meeting.',
        subtitle: '2025-08-01',
        action: null,
        button: null,
        btn_hover: null,
        content: (
          <div>
            Please note that the YEGWIMSS 2025 Annual General Meeting is
            scheduled to take place at Miquelon Lake Provincial Park on August
            9, 2025, weather permitting. Use this form to register your
            attendance{' '}
            <span>
              <a
                style={{ display: 'table-cell' }}
                href='https://forms.gle/tTFcsia7MN9d4EV18'
                target='_blank'
                rel='noreferrer'>
                AGM RSVP
              </a>
            </span>
            . If weather conditions do not allow for an in-person gathering,
            members may join the virtual meeting using this link{' '}
            <span>
              <a
                style={{ display: 'table-cell' }}
                href='https://meet.google.com/bat-qeku-aev'
                target='_blank'
                rel='noreferrer'>
                Join AGM Meeting
              </a>
            </span>{' '}
            or link below, beginning at 10:00 a.m. on the same day.
          </div>
        ),
      },
      {
        id: 3,
        title: 'WIMSS Tai Chi Practice Group Started',
        subtitle: '2025-09-17',
        action: null,
        button: null,
        btn_hover: null,
        content:
          "Promote your well-being with the new WIMSS Tai Chi Practice Group! We're starting sessions for the 2025-2026 school year—come and find your balance with us.",
      },
    ],
  },
  {
    page: 'sponsors',
    title: 'Our Sponsors',
    description:
      'We extend our heartfelt gratitude to our sponsors, whose generous support plays a vital role in our mission to build a socially accountable society. Your contributions enable us to create impactful programs, foster sustainable community growth, and inspire positive change. As partners in this journey, you exemplify the values of trust and responsibility, helping to shape a brighter, more equitable future for all. Together, we are making a lasting difference. Thank you for believing in and supporting our vision.',
    paragraphs: [
      // {
      //   id: 0,
      //   title: 'Latest News and Events',
      //   subtitle: null,
      //   action: null,
      //   button: null,
      //   btn_hover: null,
      //   content:
      //     "Welcome to the WIMSS's latest updates! We're thrilled to share some exciting news and events happening in our community. Stay tuned for updates on our projects, volunteer opportunities, and stories of change as we work together to make a difference!",
      // },
      {
        id: 1,
        title: 'Government of Alberta',
        // icon: <Avatar alt='City of Edmonton' src={COELogo} sx={TabIconSize} />,
        image: GOALogo,
        website: 'https://www.alberta.ca/',
        content:
          'The Government of Alberta proudly supports building inclusive, diverse communities where every individual can thrive. By investing in vital social programs, community initiatives, and accessible healthcare, the province plays a foundational role in enhancing daily living conditions and protecting the long-term health and well-being of all Albertans.',
      },
      {
        id: 2,
        title: 'City of Edmonton',
        // icon: <Avatar alt='City of Edmonton' src={COELogo} sx={TabIconSize} />,
        image: COELogo,
        website: 'https://www.edmonton.ca/',
        content:
          'The City of Edmonton is a shining example of a community supporter, dedicated to fostering inclusivity, growth, and well-being. Through its innovative programs, unwavering local support, and commitment to create vibrant spaces, Edmonton empowers communities to thrive. Their dedication to partnerships and meaningful impact makes them a cornerstone of positive change in the region.',
      },
      {
        id: 3,
        title: 'EPCOR',
        // icon: <Avatar alt='EPCOR' src={EPCORLogo} sx={TabIconSize} />,
        image: EPCORLogo,
        website: 'https://www.epcor.com/ca/en.html',
        content:
          'EPCOR is a leading utility provider, delivering reliable water, power, and natural gas services across diverse regions with industry excellence. Beyond their operational expertise, EPCOR is a steadfast supporter of communities, investing in initiatives that foster growth, sustainability, and well-being. Their commitment to both innovation and community impact sets them apart as a trusted partner and leader.',
      },
    ],
  },
  {
    page: 'about-us',
    title: '关于我们',
    description: (
      <div>
        At YEG Wellness-In-Motion Synergy Society, we are committed to driving
        positive change through engaging events, sharing life experiences,
        fostering sustainable community development, and supporting one another.
        Our diverse team of dedicated experts works passionately to transform
        lives and strengthen communities. We'd love to hear your ideas and
        feedback! Feel free to reach out to us at{' '}
        <span>
          <a
            style={{ display: 'table-cell' }}
            href='mailto:info@wimss.org'
            target='_blank'
            rel='noreferrer'>
            info@wimss.org
          </a>
        </span>
        {'. '}
      </div>
    ),
    paragraphs: [
      // {
      //   id: 0,
      //   title: 'Latest News and Events',
      //   subtitle: null,
      //   action: null,
      //   button: null,
      //   btn_hover: null,
      //   content:
      //     "Welcome to the WIMSS's latest updates! We're thrilled to share some exciting news and events happening in our community. Stay tuned for updates on our projects, volunteer opportunities, and stories of change as we work together to make a difference!",
      // },
      {
        id: 1,
        name: 'Ning Zheng',
        title: 'President',
        image: NingBio,
        content:
          'Ning is a dedicated technology enthusiast with expertise in full-stack React development, deep learning technologies, and geospatial analysis. Ning is also a senior property appraiser with over 20 years of expertise in property assessment and taxation. In his free time, he enjoys playing indoor volleyball and embarking on outdoor adventures.',
      },
      {
        id: 2,
        name: 'Jianbo Lu',
        title: 'Director',
        image: JianboBio,
        content:
          'Jianbo, an experienced Senior Bioresource Engineer, has developed a growing appreciation for sports over the years. He enjoys hiking in the Rocky Mountains and exploring serene lakes during his vacations. Recently, he has also discovered a passion for team sports like volleyball and pickleball, along with playing card games with friends.',
      },
      {
        id: 3,
        name: 'Zhaohui Gao',
        title: 'Director',
        image: ZhaohuiBio,
        content:
          'A sports lover. Like watching European soccer   and NBA basketball, also like playing bridge, table Tennis, pickle ball & hiking.',
      },
      {
        id: 4,
        name: 'Jeff Zhuang',
        title: 'Director/Treasurer',
        image: JeffBio,
        content:
          'Jeff Zhuang, a Chartered Professional Accountant in Canada, has a wide range of interests, including music, movies, travel, bowling, volleyball, and board games. He is passionate about coffee and roasting coffee beans.',
      },
      {
        id: 5,
        name: 'Charlie Wang',
        title: 'Director',
        image: CharlieBio,
        content:
          'Gifted libero, loves new ideas and technologies. Good at horticulture, loves gardening. Enjoy playing volleyball, pickleball and Tai Chi with friends, also enjoy playing weiqi, bridge and other card games.',
      },
    ],
  },
  {
    page: 'join-us',
    title: 'Our Team',
    description: (
      <div>
        Join us and become part of a society that values trust, integrity, and
        social accountability. Here, your contributions will have a meaningful
        impact, as we work together to create a transparent and ethical
        community that uplifts everyone. By joining, you align yourself with
        individuals who are committed to making a difference, fostering
        innovation, and driving positive change. Together, we build not just a
        network but a legacy of trust and responsibility for a brighter future.
        Join us today by filling out the membership form:{' '}
        <span>
          <a
            style={{ display: 'table-cell' }}
            href='https://forms.gle/8MheWcexj2X2KYC59'
            target='_blank'
            rel='noreferrer'>
            WIMSS registration form
          </a>
        </span>
        {'. '}
      </div>
    ),
    paragraphs: [
      // {
      //   id: 0,
      //   title: 'Latest News and Events',
      //   subtitle: null,
      //   action: null,
      //   button: null,
      //   btn_hover: null,
      //   content:
      //     "Welcome to the WIMSS's latest updates! We're thrilled to share some exciting news and events happening in our community. Stay tuned for updates on our projects, volunteer opportunities, and stories of change as we work together to make a difference!",
      // },
      {
        id: 1,
        name: 'Ning Zheng',
        title: 'CEO',
        image: NingBio,
        content:
          'Ning is a dedicated technology enthusiast with expertise in full-stack React development, deep learning technologies, and geospatial analysis. Ning is also a senior property appraiser with over 20 years of expertise in property assessment and taxation. In his free time, he enjoys playing indoor volleyball and embarking on outdoor adventures.',
      },
    ],
  },
];

export const WebsiteTextsChn = [
  {
    page: 'home',
    paragraphs: [
      {
        id: 0,
        title: '欢迎来到爱城活力在线社团(YEGWIMSS)',
        subtitle: '寻觅更健康、更快乐的你!',
        action: null,
        button: null,
        btn_hover: null,
        content: null,
      },
      {
        id: 1,
        title: null,
        subtitle: '多姿多彩的活动项目',
        action: '/activities',
        button: BeActiveChnBtn,
        btn_hover: BeActiveChnHoverBtn,
        content:(
          <div>
            欢迎你加入爱城活力在线社团(简称活力社)。这是一个致力于通过各种休闲活动，如户外活动、室内运动、健身等，促进全面健康和均衡生活方式的社区。无论你是想提升心理、身体或情感健康，还是想结识志同道合的朋友和家人，我们的社团都会在你的健康之旅中提供支持和指导。{' '}
            <span>
              <strong>
                我们最近举办的 WIMSS Day 2026 徒步活动取得了圆满成功！
                {' '}
                点击下方按钮，了解更多活动详情！
              </strong> 
            </span>
          </div>
        ),
        // content:
        //   '欢迎你加入爱城活力在线社团(简称活力社)。这是一个致力于通过各种休闲活动，如户外活动、室内运动、健身等，促进全面健康和均衡生活方式的社区。无论你是想提升心理、身体或情感健康，还是想结识志同道合的朋友和家人，我们的社团都会在你的健康之旅中提供支持和指导。',
      },
      {
        id: 2,
        title: null,
        subtitle: '全方位健康是我们的追求',
        action: '/schedules',
        button: LiveHealthierChnBtn,
        btn_hover: LiveHealthierChnHoverBtn,
        content:
          '在活力社，我们相信健康不仅仅是身体健康——它还包括心灵、身体和灵魂全方位的保健。我们的活动种类丰富，包括生活经验分享会、室内外活动、营养讲座、低强度运动和压力疏导体验等。我们致力于创造一个正能量、包容的环境，让成员能够相互联系、分享见解，并探索如何才能创造属于自己的平安和快乐的生活。\n作为社团的一员，你将有机会参加各种活动，享受社团资源，帮助你过上更健康、更均衡的生活。无论你是健康生活的新手还是有经验的实践者，这里都有适合每个人的活动，我们鼓励你积极参与、投入其中，与我们共同成长。',
      },
      {
        id: 3,
        title: null,
        subtitle: '创建充满快乐和关爱的社区是我们的宗旨',
        action: '/join-us',
        button: ThriveTogetherChnBtn,
        btn_hover: ThriveTogetherChnHoverBtn,
        content:
          '我们期待与您一同分享这段旅程，帮助您在生活的各个方面培养健康。加入我们，共同创建一个相互支持、充满活力, 致力于全方位康健、个人成长和彼此关爱的社区!\n祝愿你更健康、更快乐!',
      },
    ],
  },
  {
    page: 'activities',
    paragraphs: [
      {
        id: 0,
        title: '丰富多彩的活动尽在活力社',
        subtitle: '必有一款适合您，敬请期待',
        action: null,
        button: null,
        btn_hover: null,
        content: null,
      },
      {
        id: 1,
        title: null,
        subtitle: '带上你们的护膝——去打排球吧！',
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: VolleyballHoverBtn,
        content:
          '欢迎加入活力社排球队！这是一个由非专业排球爱好者组成的社区，大家因为对排球的热爱和它带来的快乐而聚在一起。在这里，我们更注重娱乐、健康和团队精神，而非竞争，所以不用担心犯错 - 这只是游戏的一部分！无论你是初学者还是有经验的球员, 我们的目标是创造一个温馨友好的环境，让每个人都能享受排球的乐趣、保持活力，并在娱乐过程中建立友谊。',
      },
      {
        id: 2,
        title: null,
        subtitle: '是时候挥拍击球了——匹克球场见！',
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: PickleballHoverBtn,
        content:
          '来吧，匹克球爱好者们！这是一个由业余匹克球爱好者组成的充满活力的社区，大家因对运动的热爱、娱乐和健康而相聚。作为当下最受欢迎的运动之一，匹克球为各个水平的玩家带来了激情与健康的完美结合。在这里，我们倡导共享球场、传递快乐，营造一个友好且包容的环境，让每个人都能享受比赛、保持活力，并建立持久的友谊。',
      },
      {
        id: 3,
        title: null,
        subtitle: '穿上登山鞋——是时候去探索大自然了！',
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: HikingHoverBtn,
        content:
          '欢迎加入活力社户外探索小组！在这里，我们欣赏自然之美，同时致力于保护环境。从徒步、露营到滑雪等多种活动，我们精心策划了丰富多样的行程和活动，满足各类户外爱好者的兴趣和技能水平。除了探索的刺激，我们的小组更注重建立一个社区，与志同道合的自然爱好者创造持久的友谊。加入我们，一起探索精彩的户外世界，保持活力，并为环境带来积极的影响吧！',
      },
      {
        id: 4,
        title: null,
        subtitle: '太极 — 动静皆从容!',
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: TaichiHoverBtn,
        content:
          '欢迎加入活力社太极组! 爱城活力社太极组是由习练太极多年的拳友组成，主要练习24式，48式，吴式，陈氏太极拳架，还有太极推手练习。',
      },
      {
        id: 5,
        title: null,
        subtitle: '',
        action: '/schedules',
        button: CoconutDrinkIcon,
        btn_hover: WimssdayHoverBtn,
        content: (
          <WIMSSDayCN />
        ),
      },
    ],
  },
  {
    page: 'schedules',
    paragraphs: [
      {
        id: 0,
        title: null,
        subtitle: null,
        action: null,
        button: null,
        btn_hover: null,
        content: null,
      },
      {
        id: 1,
        title: null,
        subtitle: '本赛季剩余的排球场地时间表',
        action: null,
        button: null,
        btn_hover: null,
        content: '请仔细查看本赛季剩余的激动人心的排球比赛的日期和场地!',
      },
      {
        id: 2,
        title: null,
        subtitle: '本赛季剩余的匹克球场地时间表',
        action: null,
        button: null,
        btn_hover: null,
        content: '请仔细查看本赛季剩余的最受欢迎的匹克球比赛的日期和场地!',
      },
      {
        id: 3,
        title: null,
        subtitle: '我们的户外探索小组没有具体的时间安排!',
        action: null,
        button: null,
        btn_hover: null,
        content: '请加入我们的户外探索小组微信群，参与全年精彩的户外探索活动!',
      },
      {
        id: 4,
        title: null,
        subtitle: '本赛季剩余的太极场地时间表',
        action: null,
        button: null,
        btn_hover: null,
        content: '请仔细查看本赛季剩余的太极的日期和场地!',
      },
    ],
  },
  {
    page: 'news',
    paragraphs: [
      // {
      //   id: 0,
      //   title: 'Latest News and Events',
      //   subtitle: null,
      //   action: null,
      //   button: null,
      //   btn_hover: null,
      //   content:
      //     "Welcome to the WIMSS's latest updates! We're thrilled to share some exciting news and events happening in our community. Stay tuned for updates on our projects, volunteer opportunities, and stories of change as we work together to make a difference!",
      // },
      {
        id: 0,
        title: '爱城活力社已加入Edmonton Corporate Wellness Program。',
        subtitle: '2024-11-15',
        action: null,
        button: null,
        btn_hover: null,
        content: (
          <div>
            爱城活力社已加入Edmonton Corporate Wellness
            Program。我们的会员可享受会员的专属折扣！年度会员或连续月会员可享
            20% 折扣，多次入场通票（5 次及以上）可享 15% 折扣。详情请访问{' '}
            <span>
              <a
                style={{ display: 'table-cell' }}
                href='https://www.edmonton.ca/activities_parks_recreation/corporate-wellness-program'
                target='_blank'
                rel='noreferrer'>
                Corporate Wellness Program
              </a>
            </span>
            . 如需享受这些优惠，请向爱城活力社申请{' '}
            <span>
              <a
                style={{ display: 'table-cell' }}
                href='mailto:info@wimss.org'
                target='_blank'
                rel='noreferrer'>
                会员确认信
              </a>
            </span>
            。
          </div>
        ),
      },
      {
        id: 1,
        title: '爱城活力社获得了EPCOR的慷慨赞助。',
        subtitle: '2024-12-18',
        action: null,
        button: null,
        btn_hover: null,
        content:
          '爱城活力社衷心感谢陆燕、刘静泉两位会员通过EPCOR的努力，为我们协会争取到宝贵的赞助支持！这份支持对我们徒步户外探索及其他活动的成功举办奠定了坚实基础。EPCOR公司的支持更让我们感受到企业对公益事业的关注与社会责任感。正因为有EPCOR公司这样的伙伴，我们才能更加坚定地为会员们创造幸福、健康的集体生活!',
      },
      {
        id: 2,
        title: '爱城活力社2025年度大会。',
        subtitle: '2025-08-01',
        action: null,
        button: null,
        btn_hover: null,
        content: (
          <div>
            请注意，爱城活力社2025年度大会计划于2025年8月9日在Miquelon
            Lake省立公园举行， 视天气情况而定。请使用此表格登记您的出席情况{' '}
            <span>
              <a
                style={{ display: 'table-cell' }}
                href='https://forms.gle/tTFcsia7MN9d4EV18'
                target='_blank'
                rel='noreferrer'>
                爱城活力社2025年度大会邀请函
              </a>
            </span>
            。 如因天气原因无法现场召开，会员可使用链接{' '}
            <span>
              <a
                style={{ display: 'table-cell' }}
                href='https://meet.google.com/bat-qeku-aev'
                target='_blank'
                rel='noreferrer'>
                爱城活力社2025年度大会
              </a>
            </span>{' '}
            参加当天上午10点开始的线上会议。
          </div>
        ),
      },
      {
        id: 3,
        title: '活力社太极练习小组闪亮登场',
        subtitle: '2025-09-17',
        action: null,
        button: null,
        btn_hover: null,
        content:
          '好消息！通过新的活力社太极练习小组来提升您的身心健康！我们将在 2025-2026 学年开始课程——快来和我们一起寻找健康吧。',
      },
    ],
  },
  {
    page: 'sponsors',
    title: '我们的赞助商',
    description:
      '我们衷心感谢各位赞助商，正是您们的慷慨支持，在我们建设一个具有社会责任感的社区的使命中发挥了至关重要的作用。您们的贡献使我们能够开展有影响力的项目，促进可持续的社区发展，并激发积极的改变。作为这一进程中的合作伙伴，您们展现了信任与责任的价值，帮助塑造一个更加光明、公平的未来。我们共同携手并产生深远的影响。感谢您们对我们愿景的信任与支持！',
    paragraphs: [
      // {
      //   id: 0,
      //   title: 'Latest News and Events',
      //   subtitle: null,
      //   action: null,
      //   button: null,
      //   btn_hover: null,
      //   content:
      //     "Welcome to the WIMSS's latest updates! We're thrilled to share some exciting news and events happening in our community. Stay tuned for updates on our projects, volunteer opportunities, and stories of change as we work together to make a difference!",
      // },
      {
        id: 1,
        title: 'Government of Alberta',
        //icon: <Avatar alt='City of Edmonton' src={COELogo} sx={TabIconSize} />,
        image: GOALogo,
        website: 'https://www.alberta.ca/',
        content:
          '阿尔伯塔省政府强烈支持建设具有包容性和多样性的社区，让每个人都能在这里蓬勃发展。通过投资至关重要的社会项目、社区倡议以及普及的医疗服务，本省在改善日常居住条件以及保护所有阿尔伯塔人的长期健康与社会福利方面发挥着基石作用。',
      },
      {
        id: 2,
        title: 'City of Edmonton',
        //icon: <Avatar alt='City of Edmonton' src={COELogo} sx={TabIconSize} />,
        image: COELogo,
        website: 'https://www.edmonton.ca/',
        content:
          '埃德蒙顿市是社区支持者的杰出典范，致力于创造具有包容性、促进发展和以人为本的社会福利的社区。通过其创新的手段、对本地议案的坚定支持以及创造充满活力空间的承诺，埃德蒙顿激励社区蓬勃发展。他们倡导合作和推动积极影响的付出，使其成为该地区积极变革的重要基石。',
      },
      {
        id: 3,
        title: 'EPCOR',
        // icon: <Avatar alt='EPCOR' src={EPCORLogo} sx={TabIconSize} />,
        image: EPCORLogo,
        website: 'https://www.epcor.com/ca/en.html',
        content:
          'EPCOR 是一家领先的公用事业供应商，以卓越的行业水平在多个地区提供可靠的水、电和天然气服务。除了卓越的运营能力外，EPCOR 还是社区的坚定支持者，积极投资于促进发展、可持续性和社会福利的各项计划。他们对创新和社区建设的承诺，使其成为值得信赖的合作伙伴和行业领导者。',
      },
    ],
  },
  {
    page: 'about-us',
    title: '关于我们',
    description: (
      <div>
        在爱城活力社，我们致力于通过精彩的活动、分享生活经验、促进可持续的社区发展以及互相支持来推动积极的改变。我们多元化的专业团队充满热情，不懈努力，致力于改变生活并加强社区建设。我们非常期待听到您的想法和反馈！欢迎通过
        <span>
          <a
            style={{ display: 'table-cell' }}
            href='mailto:info@wimss.org'
            target='_blank'
            rel='noreferrer'>
            info@wimss.org
          </a>
        </span>{' '}
        联系我们。
      </div>
    ),
    paragraphs: [
      // {
      //   id: 0,
      //   title: 'Latest News and Events',
      //   subtitle: null,
      //   action: null,
      //   button: null,
      //   btn_hover: null,
      //   content:
      //     "Welcome to the WIMSS's latest updates! We're thrilled to share some exciting news and events happening in our community. Stay tuned for updates on our projects, volunteer opportunities, and stories of change as we work together to make a difference!",
      // },
      {
        id: 1,
        name: '郑 宁',
        title: '执行官',
        image: NingBio,
        content:
          '郑宁是一位高新技术的爱好者，擅长前端和后端React开发、深度学习技术和地理空间分析。郑宁还是一位资深物业评估师，在物业评估和房地产税领域拥有超过20年的专业经验。在空闲时间，他喜欢打排球，并热衷于进行户外探险。',
      },
      {
        id: 2,
        name: '鲁健波',
        title: '董事',
        image: JianboBio,
        content:
          '健波是一位资深的生物资源工程师，多年来对运动的兴趣日益浓厚。他喜欢在假期徒步穿越落基山脉，探索宁静的湖泊。近年来，他还发现自己对团队运动如排球和匹克球充满热情，并喜欢与朋友一起玩牌。',
      },
      {
        id: 3,
        name: '高兆辉',
        title: '董事',
        image: ZhaohuiBio,
        content:
          '体育爱好者。喜欢观赏欧洲足球和NBA篮球，还喜欢桥牌、乒乓球、匹克球和徒步。',
      },
      {
        id: 4,
        name: '庄  杰',
        title: '董事/财务总监',
        image: JeffBio,
        content:
          '加拿大特许会计师，兴趣广泛，爱好音乐、电影、旅游、保龄球、排球和棋牌，热衷于咖啡和咖啡豆烘焙。',
      },
      {
        id: 5,
        name: 'Charlie Wang',
        title: '董事',
        image: CharlieBio,
        content:
          '多才多艺的自由人，爱好新生事物，喜欢琢磨新玩意儿。善于种花养草。热爱文体活动，喜欢和朋友们打排球、匹克球、练习吴家太极、下围棋、打桥牌。',
      },
    ],
  },
  {
    page: 'join-us',
    title: '加入我们',
    description: (
      <div>
        加入我们，成为一个推崇信任、诚信和社会责任的活力社的一员。在这里，您的贡献将产生深远的影响，因为我们携手共建一个透明且充满道德的社区，致力于提升每个人的生活。加入我们，您将与那些致力于改变现状、推动创新并实现积极变革的人们站在一起。让我们共同打造的不仅是一个合作平台，更是一份信任与责任的传承，为更光明的未来奠定基础。
        通过填写{' '}
        <span>
          <a
            style={{ display: 'table-cell' }}
            href='https://forms.gle/8MheWcexj2X2KYC59'
            target='_blank'
            rel='noreferrer'>
            会员申请表
          </a>
        </span>{' '}
        加入我们吧。
      </div>
    ),
    paragraphs: [
      // {
      //   id: 0,
      //   title: 'Latest News and Events',
      //   subtitle: null,
      //   action: null,
      //   button: null,
      //   btn_hover: null,
      //   content:
      //     "Welcome to the WIMSS's latest updates! We're thrilled to share some exciting news and events happening in our community. Stay tuned for updates on our projects, volunteer opportunities, and stories of change as we work together to make a difference!",
      // },
      {
        id: 1,
        name: 'Ning Zheng',
        title: 'CEO',
        image: NingBio,
        content:
          'Ning is a dedicated technology enthusiast with expertise in full-stack React development, deep learning technologies, and geospatial analysis. Ning is also a senior property appraiser with over 20 years of expertise in property assessment and taxation. In his free time, he enjoys playing indoor volleyball and embarking on outdoor adventures.',
      },
    ],
  },
];

export const ActivityTabsList = [
  {
    label: 'Volleyball',
    icon: (
      <Avatar
        alt='Volleyball'
        src={VolleyballTabIcon}
        variant='square'
        sx={TabIconSize}
      />
    ),
    // Component: <ActivityComponents />,
  },
  {
    label: 'Pickleball',
    icon: (
      <Avatar
        alt='Pickleball'
        src={PickleballTabIcon}
        variant='square'
        sx={TabIconSize}
      />
    ),
    // Component: <ActivityComponents />,
  },
  {
    label: 'Outdoor',
    icon: (
      <Avatar
        alt='Outdoor'
        src={HikingTabIcon}
        variant='square'
        sx={TabIconSize}
      />
    ),
    // Component: <ActivityComponents />,
  },
  {
    label: 'Taichi',
    icon: (
      <Avatar
        alt='Taichi'
        src={TaichiTabIcon}
        variant='square'
        sx={TabIconSize}
      />
    ),
    // Component: <ActivityComponents />,
  },
  {
    label: 'Wimssday',
    icon: (
      <Avatar
        alt='WIMSS Day 2026'
        src={WimssDayTabIcon}
        variant='square'
        sx={TabIconSize}
      />
    ),
    // Component: <ActivityComponents />,
  },

];
